import { AuthPage } from "components/pages/auth";
import { RegisterPage } from "components/pages/auth/components";

export const Register = () => {
  return <AuthPage type="register" />;
};
